export const actionTypes: any = {
  // get
  GET_PRODUCT_SCHEME_START: 'GET_PRODUCT_SCHEME_START',
  GET_PRODUCT_SCHEME_SUCCESS: 'GET_PRODUCT_SCHEME_SUCCESS',
  GET_PRODUCT_SCHEME_FINISH: 'GET_PRODUCT_SCHEME_FINISH',
  // get
  GET_PRODUCT_SCHEME_DROPDOWN_START: 'GET_PRODUCT_SCHEME_DROPDOWN_START',
  GET_PRODUCT_SCHEME_DROPDOWN_SUCCESS: 'GET_PRODUCT_SCHEME_DROPDOWN_SUCCESS',
  GET_PRODUCT_SCHEME_DROPDOWN_FINISH: 'GET_PRODUCT_SCHEME_DROPDOWN_FINISH',
  // add
  ADD_PRODUCT_SCHEME_START: 'ADD_PRODUCT_SCHEME_START',
  ADD_PRODUCT_SCHEME_SUCCESS: 'ADD_PRODUCT_SCHEME_SUCCESS',
  ADD_PRODUCT_SCHEME_FINISH: 'ADD_PRODUCT_SCHEME_FINISH',
  ADD_PRODUCT_SCHEME_FAILURE: 'ADD_PRODUCT_SCHEME_FAILURE',
  ADD_PRODUCT_SCHEME_RESET: 'ADD_PRODUCT_SCHEME_RESET',
  // update
  UPDATE_PRODUCT_SCHEME_START: 'UPDATE_PRODUCT_SCHEME_START',
  UPDATE_PRODUCT_SCHEME_SUCCESS: 'UPDATE_PRODUCT_SCHEME_SUCCESS',
  UPDATE_PRODUCT_SCHEME_FINISH: 'UPDATE_PRODUCT_SCHEME_FINISH',
  UPDATE_PRODUCT_SCHEME_RESET: 'UPDATE_PRODUCT_SCHEME_RESET',

  // delete
  DELETE_PRODUCT_SCHEME_START: 'DELETE_PRODUCT_SCHEME_START',
  DELETE_PRODUCT_SCHEME_SUCCESS: 'DELETE_PRODUCT_SCHEME_SUCCESS',
  DELETE_PRODUCT_SCHEME_FINISH: 'DELETE_PRODUCT_SCHEME_FINISH',

  // bulk/single active department
  SINGLE_ACTIVATE_PRODUCT_SCHEME_REQUEST: 'SINGLE_ACTIVATE_PRODUCT_SCHEME_REQUEST',
  SINGLE_ACTIVATE_PRODUCT_SCHEME_SUCCESS: 'SINGLE_ACTIVATE_PRODUCT_SCHEME_SUCCESS',
  SINGLE_ACTIVATE_PRODUCT_SCHEME_FINISH: 'SINGLE_ACTIVATE_PRODUCT_SCHEME_FINISH',

  // bulk/single deactive department
  SINGLE_DEACTIVATE_PRODUCT_SCHEME_REQUEST: 'SINGLE_DEACTIVATE_PRODUCT_SCHEME_REQUEST',
  SINGLE_DEACTIVATE_PRODUCT_SCHEME_SUCCESS: 'SINGLE_DEACTIVATE_PRODUCT_SCHEME_SUCCESS',
  SINGLE_DEACTIVATE_PRODUCT_SCHEME_FINISH: 'SINGLE_DEACTIVATE_PRODUCT_SCHEME_FINISH',
}
